/*
 * © 2017 Stratio Big Data Inc., Sucursal en España.
 *
 * This software is licensed under the Apache License, Version 2.0.
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the terms of the License for more details.
 *
 * SPDX-License-Identifier: Apache-2.0.
 */
import { StAlertsDemoModule } from './st-alert-demo/st-alerts-demo.module';
import { StBreadcrumbsDemoModule } from './st-breadcrumbs-demo/st-breadcrumbs-demo.module';
import { StBubbleDemoModule } from './st-bubble-demo/st-bubble-demo.module';
import { StButtonDemoModule } from './st-button-demo/st-button-demo.module';
import { StCheckboxDemoModule } from './st-checkbox-demo/st-checkbox-demo.module';
import { StDropdownMenuDemoModule } from './st-dropdown-menu-demo/st-dropdown-menu-demo.module';
import { StFileButtonDemoModule } from './st-file-button-demo/st-file-button-demo.module';
import { StForegroundNotificationsDemoModule } from './st-foreground-notifications-demo/st-foreground-notifications-demo.module';

import { StFormDemoModule } from './st-form-demo/st-form-demo.module';
import { StFormListDemoModule } from './st-form-list-demo/st-form-list-demo.module';

import { StFullscreenLayoutDemoModule } from './st-fullscreen-layout-demo/st-fullscreen-layout-demo.module';
import { StHeaderDemoModule } from './st-header-demo/st-header-demo.module';
import { StHorizontalTabsDemoModule } from './st-horizontal-tabs-demo/st-horizontal-tabs-demo.module';
import { StInfoBoxDemoModule } from './st-info-box-demo/st-info-box-demo.module';
import { StInputDemoModule } from './st-input-demo/st-input-demo.module';
import { StLabelDemoModule } from './st-label-demo/st-label-demo.module';
import { StMenuDemoModule } from './st-menu-demo/st-menu-demo.module';
import { StModalDemoModule } from './st-modal-demo/st-modal-demo.module';
import { StModal2DemoModule } from './st-modal2-demo/st-modal2-demo.module';
import { StPaginationDemoModule } from './st-pagination-demo/st-pagination-demo.module';
import { StPopOverDemoModule } from './st-pop-over-demo/st-pop-over-demo.module';
import { StProgressBarDemoModule } from './st-progress-bar-demo/st-progress-bar-demo.module';
import { StRadioDemoModule } from './st-radio-demo/st-radio-demo.module';
import { StRadioMenuDemoModule } from './st-radio-menu-demo/st-radio-menu-demo.module';
import { StSearchDemoModule } from './st-search-demo/st-search-demo.module';
import { StSelectDemoModule } from './st-select-demo/select-demo.module';
import { StSidebarDemoModule } from './st-sidebar-demo/st-sidebar-demo.module';
import { StSpinnerDemoModule } from './st-spinner-demo/st-spinner-demo.module';
import { StSwitchDemoModule } from './st-switch-demo/st-switch-demo.module';
import { StTableDemoModule } from './st-table-demo/st-table-demo.module';
import { StTagInputDemoModule } from './st-tag-input-demo/st-tag-input-demo.module';
import { StTextareaDemoModule } from './st-textarea-demo/st-textarea-demo.module';
import { StToggleButtonsDemoModule } from './st-toggle-buttons-demo/st-toggle-buttons-demo.module';
import { StTooltipDemoModule } from './st-tooltip-demo/st-tooltip-demo.module';
import { StTwoListSelectionDemoModule } from './st-two-list-selection-demo/st-two-list-selection-demo.module';
import { StVerticalTabsDemoModule } from './st-vertical-tabs-demo/st-vertical-tabs-demo.module';
import { StFilterSelectorDemoModule } from './st-filter-selector-demo/st-filter-selector-demo.module';
import { StZeroPageDemoModule } from './st-zero-page-demo/st-zero-page-demo.module';
import { StColorPickerDemoModule } from './st-color-picker-demo/st-color-picker-demo.module';
import { StBubbleOnEllipsisDemoModule } from '@app/demos/st-bubble-on-ellipsis-demo/st-bubble-on-ellipsis-demo.module';
import { StVerticalIconTabsModule } from '@stratio/egeo';
import { StTagDemoModule } from '@app/demos/st-tag-demo/st-tag-demo.module';
import { StDynamicTableDemoModule } from '@app/demos/st-dynamic-table-demo/st-dynamic-table-demo.module';


export const EGEO_DEMO_MODULES: any[] = [
   // Demos
   StAlertsDemoModule,
   StBreadcrumbsDemoModule,
   StBubbleDemoModule,
   StBubbleOnEllipsisDemoModule,
   StButtonDemoModule,
   StCheckboxDemoModule,
   StColorPickerDemoModule,
   StDropdownMenuDemoModule,
   StFileButtonDemoModule,
   StFilterSelectorDemoModule,
   StForegroundNotificationsDemoModule,
   StFormDemoModule,
   StFormListDemoModule,
   StFullscreenLayoutDemoModule,
   StHeaderDemoModule,
   StHorizontalTabsDemoModule,
   StInfoBoxDemoModule,
   StInputDemoModule,
   StLabelDemoModule,
   StMenuDemoModule,
   StModalDemoModule,
   StModal2DemoModule,
   StPaginationDemoModule,
   StPopOverDemoModule,
   StProgressBarDemoModule,
   StRadioDemoModule,
   StRadioMenuDemoModule,
   StSearchDemoModule,
   StSelectDemoModule,
   StSidebarDemoModule,
   StSpinnerDemoModule,
   StSwitchDemoModule,
   StDynamicTableDemoModule,
   StTableDemoModule,
   StTagDemoModule,
   StTagInputDemoModule,
   StTextareaDemoModule,
   StToggleButtonsDemoModule,
   StTooltipDemoModule,
   StTwoListSelectionDemoModule,
   StVerticalIconTabsModule,
   StVerticalTabsDemoModule,
   StZeroPageDemoModule
];
